import { Component, OnInit } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState, loginStateLocaleList } from "src/app/store/reducers";
import { getLocales } from "src/app/store/actions/login/login.actions";

import { UserLocaleDTO } from "src/app/models/UserDetails/userLocaleDTO";
import { UserProfileCodes } from "src/app/models/UserDetails/userProfileDTO";

const devLocale = {
  code: "dev-dev",
  description: "Languages.Dev",
  enabled: true,
};

@Component({
  selector: "app-language-select",
  templateUrl: "./language-select.component.html",
  styleUrls: ["./language-select.component.scss"],
})
export class LanguageSelectComponent implements OnInit {
  public selectedLanguage: any;
  public languages: any[];

  //Locales
  localesList$: Observable<UserLocaleDTO[]>;
  localesList: UserLocaleDTO[];
  localesListSub: Subscription;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService
  ) {
    this.localesList$ = this.store.pipe(select(loginStateLocaleList));
  }

  ngOnInit() {
    this.loadLocales();
  }

  loadLocales() {
    this.localesListSub = this.localesList$.subscribe((locales) => {
      if (locales) {
        this.localesList = locales;
        this.setLanguage();
      }
    });
    this.store.dispatch(getLocales({ options: { enabled: true }}));
  }

  setLanguage() {
    let userTypeCode = localStorage.getItem("profileCode");

    if (userTypeCode === UserProfileCodes.ADMINISTRATOR) {
      this.localesList = [...this.localesList, devLocale];
    }

    let sessionLanguage = localStorage.getItem("localeCode");
    this.translate.use(sessionLanguage);

    this.selectedLanguage = this.localesList.find(
      (locale) => sessionLanguage === locale.code.split("-")[0]
    );
  }

  changeLang() {
    const { code } = this.selectedLanguage;
    const splitedCode = code.split("-")[0];

    if (splitedCode !== "dev") {
      window.location.reload();
    } else {
      this.localesList.forEach((locale) => {
        if (locale.code !== "dev-dev") {
          this.translate.resetLang(locale.code.split("-")[0]);
        }
      });
      this.translate.use(splitedCode);
    }

    localStorage.setItem("localeCode", splitedCode);
    localStorage.setItem("locale", code);
  }
}
